import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useRouter, LocationContext } from './Hooks';
import { extractParams, currentUrl } from './Utils';

const RouteProps = {
	path: PropTypes.string.isRequired,
	exact: PropTypes.bool,
	nested: PropTypes.bool,
	immutable: PropTypes.bool,
	render: PropTypes.element.isRequired,
};

const RouteDefault = {
	exact: true,
	nested: false,
	immutable: false,
	subrouter: false,
};

export const Route = ({
	path,
	render,
	exact,
	nested,
	immutable,
	subrouter,
}) => {
	const {
		state: { url, matched },
		setState,
	} = useRouter();
	const { isMatched, parameters } = extractParams(
		path,
		url,
		exact,
		nested || subrouter
	);

	useEffect(() => {
		if (isMatched && !(nested || matched)) {
			if (!immutable) {
				document.documentElement.scrollTop = 0;
			}
			setState((prev) => ({ ...prev, matched: true, isNoMatched: false }));
		}
	}, [url, nested, immutable, isMatched, matched, setState]);

	return isMatched ? (
		<LocationContext.Provider
			value={{
				path,
				url: currentUrl(path, url),
				parameters,
			}}>
			{render}
		</LocationContext.Provider>
	) : null;
};

Route.propTypes = RouteProps;

Route.defaultProps = RouteDefault;
